export default "__VITE_ASSET__U3VqOFUc__"